import {
  editEvent,
  removeEvent,
  updateEvents,
  editEventAtomic,
  updateEventTeams,
} from './actions';

export default {
  [editEvent]: (state, { payload: { data } }) => {
    const { id, ...rest } = data;

    return {
      ...state,
      events: {
        ...state.events,
        [id]: {
          ...state.events[id],
          ...rest,
        },
      },
    };
  },
  [removeEvent]: (state, { payload: { data: { id, deletedAt, deletedBy } } }) => ({
    ...state,
    events: {
      ...state.events,
      [id]: {
        ...state.events[id],
        deletedAt,
        deletedBy,
        archived: true,
      },
    },
  }),
  [updateEvents]: (state, { payload: { data } }) => ({
    ...state,
    events: {
      ...state.events,
      ...data,
    },
  }),
  [updateEventTeams]: (state, { payload: { data } }) => ({
    ...state,
    events: {
      ...state.events,
      [data.id]: {
        ...state.events[data.id],
        ...data,
      },
    },
  }),
  [editEventAtomic]: (state, { payload: { id, field, value, updatedAt, updatedBy } }) => ({
    ...state,
    events: {
      ...state.events,
      [id]: {
        ...state.events[id],
        [field]: value,
        updatedAt,
        updatedBy,
      },
    },
  }),
};
